import { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";

type FullPageScreenProps = {
  children: ReactNode;
  hero?: ReactNode;
  containerClassName?: string;
} & HTMLAttributes<HTMLDivElement>;

export function FullPageScreen({
  children,
  hero,
  className,
  containerClassName,
  ...props
}: FullPageScreenProps) {
  return (
    <div className={cn("h-full lg:overflow-y-scroll", containerClassName)}>
      {hero}
      <div
        className={cn("mx-auto h-full max-w-7xl px-3 py-6 sm:p-6", className)}
        {...props}
      >
        {children}
      </div>
    </div>
  );
}
